import alexia from './alexia.jpg';
import alice from './alice.jpg';
import brendon from './brendon.jpg';
import mark from './mark.jpg';
import john from './john.jpg';
import matt from './matt.jpg';

export default [
    {
        name: 'Brendon Major',
        role: 'General Manager',
        image: brendon
    },
    {
        name: 'Matthew Percy',
        role: 'Group Business Manager',
        image: matt
    },
    {
        name: 'Alexia Green',
        role: 'Accounts Manager',
        image: alexia
    },
    {
        name: 'Alice Ewing',
        role: 'IT Technician',
        image: alice
    },
    {
        name: 'Mark Bushell',
        role: 'IT Technician',
        image: mark
    },
    {
        name: 'John Calvert',
        role: 'IT Technician',
        image: john
    }
]